// Auto-rotating image slider for the login page's .auth-visual panel.
// Advances on a timer and supports jumping to a slide via the dot buttons.

var rotateInterval = null

function showSlide(slider, index) {
  var slides = slider.querySelectorAll('.auth-slide')
  var dots = slider.querySelectorAll('.auth-slider-dot')
  if (!slides.length) return

  var next = ((index % slides.length) + slides.length) % slides.length

  slides.forEach(function (slide, i) {
    slide.classList.toggle('is-active', i === next)
  })
  dots.forEach(function (dot, i) {
    dot.classList.toggle('is-active', i === next)
  })

  slider.dataset.activeIndex = next
}

function startRotation(slider) {
  clearInterval(rotateInterval)
  rotateInterval = setInterval(function () {
    var current = parseInt(slider.dataset.activeIndex || '0', 10)
    showSlide(slider, current + 1)
  }, 5000)
}

document.addEventListener('turbolinks:load', function () {
  var slider = document.querySelector('.js-auth-slider')
  if (!slider) return

  slider.dataset.activeIndex = '0'
  startRotation(slider)
})

document.addEventListener('click', function (event) {
  var dot = event.target.closest('.auth-slider-dot')
  if (!dot) return

  var slider = dot.closest('.js-auth-slider')
  if (!slider) return

  showSlide(slider, parseInt(dot.dataset.slideIndex, 10))
  startRotation(slider)
})
